import { useQuery } from "@corpuscomplete/zero-data-transformer/react";
import { useMemo } from "react";
import { AccessGrant } from "@corpuscomplete/core/auth/grant";
import { queries } from "@corpuscomplete/core/zero";

export namespace AuthUI {
  export function usePermissions<T extends AccessGrant.Permissions>(
    permissions: T,
    resourceIds: AccessGrant.ResourceIds<T[keyof T]>,
  ) {
    const [grants] = useQuery(queries.accessGrant.myGrants());

    const resourceIdsKey =
      typeof resourceIds === "string" ? resourceIds : JSON.stringify(resourceIds);

    return useMemo(
      () => AccessGrant.checkPermissions(grants, permissions, resourceIds),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [grants, resourceIdsKey],
    );
  }
}
